module.exports = __webpack_public_path__ + "img/card_at_requisitionmanagement.366dfc10.svg";